import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import Empty from '@osui/empty';
import zhCN from 'antd/lib/locale/zh_CN';
export var BrandContext = /*#__PURE__*/React.createContext({
  brand: undefined
});
var iCloudConfigs = {
  autoInsertSpaceInButton: false,
  renderEmpty: function renderEmpty(componentName) {
    switch (componentName) {
      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Mentions':
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, "\u672A\u67E5\u5230\u4EFB\u4F55\u7ED3\u679C");

      case 'Table':
      case 'List':
        return /*#__PURE__*/React.createElement(Empty, null);

      default:
        return /*#__PURE__*/React.createElement(Empty, null);
    }
  },
  locale: zhCN
};

var BrandProvider = function BrandProvider(_ref) {
  var brand = _ref.brand,
      children = _ref.children;
  var context = {
    brand: brand
  };

  if (brand === 'icloud') {
    return /*#__PURE__*/React.createElement(BrandContext.Provider, {
      value: context
    }, /*#__PURE__*/React.createElement(_ConfigProvider, _objectSpread({}, iCloudConfigs), children));
  }

  return /*#__PURE__*/React.createElement(BrandContext.Provider, {
    value: context
  }, children);
};

export var useBrandContext = function useBrandContext() {
  return useContext(BrandContext);
};
export default BrandProvider;
//# sourceMappingURL=index.js.map